import { IconWrapper } from '../runtime';
export default IconWrapper('sticky-note-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 25 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0.5 3.75C0.5 1.67893 2.17893 0 4.25 0H20.75C22.8211 0 24.5 1.67893 24.5 3.75V20.25C24.5 22.3211 22.8211 24 20.75 24H4.25C2.17893 24 0.5 22.3211 0.5 20.25V3.75Z",
      "fill": 'url(#' + props.id + 'b24d3a25' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M13.9084 13.2744C12.5791 14.6037 10.921 15.2072 9.50055 15.4647C9.43171 15.4772 9.36374 15.4888 9.29674 15.4996C9.30752 15.4326 9.31913 15.3646 9.33161 15.2958C9.58913 13.8754 10.1926 12.2172 11.522 10.8879C12.8875 9.52232 14.9742 8.53192 16.9236 7.87269C16.2644 9.82214 15.274 11.9088 13.9084 13.2744ZM17.6428 5.29904C19.0565 4.90688 20.0434 4.75293 20.0434 4.75293C20.0434 4.75293 19.8894 5.73981 19.4973 7.15354C18.8755 9.39517 17.6548 12.71 15.4994 14.8654C13.1047 17.2601 9.99982 17.7798 8.26429 17.8679L7.59926 18.6341C7.31436 18.9623 6.9011 19.1508 6.46648 19.1508H4.34375L6.92666 16.5679C7.00938 14.8395 7.51962 11.7082 9.93097 9.29689C12.0864 7.14151 15.4012 5.92084 17.6428 5.29904Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + 'b24d3a25',
      "x1": "0.5",
      "y1": "0",
      "x2": "24.5",
      "y2": "24",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#FFCB3D"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#EBAC00"
    }
  })])])]);
});